import { useEffect } from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import OverFlowTooltip from '@/component/common/OverFlowTooltip';
import TooltipThumb from '@/component/common/TooltipThumb';
import { downloadFileFromS3, getLinkDownloadFileFromS3 } from '@/component/common/FileUploaded';
import { EditFileUploaded } from '@/component/common/EditFileUploaded';
import { I18n } from 'aws-amplify';

export default function ContentEmailAttachment({
    detailTicket,
    fieldData,
    setIsShowPopupLogout,
    isUnDeliverTicket,

    fileUploadList,
    setFileUploadList,
    fileUpdatedList,
    setFileUpdatedList,
    fileDeletedList,
    setFileDeletedList,
    currentAttachmentError,
    setCurrentAttachmentError,

    setIsEditedCurrentTicket,
    isDisableEdit,
    isTriggerReloadCurrentTicket,
}) {

    let props = {
        setListFieldEdited: () => {},
        name:fieldData.id,
        data:fieldData,
        selectTicketType: 'Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL',
        ticketType: Constant.TICKET_TYPE.EMAIL_REPLY,
        detailTicket: detailTicket,
        setErrorCreateTicket: () => {},
        setError: () => {},
        errorlist: [],
        fileUploading: [],
        componentName: null,
        addTicket: true,
        setValue: () => {},
        register: () => {},
        clearErrors: () => {},
        setIsEdited: setIsEditedCurrentTicket,
        isDisableEdit: isDisableEdit
    }

    // handle error attachment
    useEffect(() => {
        if (!isUnDeliverTicket) return;
        
        let totalFileSize = 0;
        if (!Utils.isEmptyArray(fileUploadList)) {
            fileUploadList.forEach(file => {
                if (file?.file?.size) {
                    totalFileSize += parseInt(file?.file?.size);
                }
            })
        }
        if (!Utils.isEmptyArray(fileUpdatedList)) {
            const currentFileList = [...fileUpdatedList].filter(f => !fileDeletedList.find(deleted => deleted.fileUrl === f.fileUrl));
            currentFileList.forEach(file => {
                if (file?.fileSize) {
                    totalFileSize += parseInt(file?.fileSize);
                }
            })
        }
        
        let convertTotalFileSizeToMB = Utils.convertByteToMB(totalFileSize);
        setCurrentAttachmentError(prev => {
            if (convertTotalFileSizeToMB > Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) {
                return I18n.get('MGS-FILE-OVER-CAPACITY').replace('{{fileSize}}', Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET)
            }
            return ''
        });
        
    }, [fileUploadList, fileUpdatedList, fileDeletedList])

    return (
        <div className='form-addTicket'>
            <div className="cell-prod-status gap-8">
                <label className='form-addTicket-label' >添付ファイル</label>
            </div>
            <div className='form-addTicket-input'>
                {isUnDeliverTicket ? (
                    <EditFileUploaded
                        defaultValue={fieldData.value}
                        fileUploadList={fileUploadList}
                        setFileUploadList={setFileUploadList}
                        fileUpdatedList={fileUpdatedList}
                        setFileUpdatedList={setFileUpdatedList}
                        setFileDeletedList={setFileDeletedList}
                        setIsShowPopupLogout={setIsShowPopupLogout}
                        attachmentError={currentAttachmentError}
                        isTriggerReloadCurrentTicket={isTriggerReloadCurrentTicket}
                        {...props}
                    />
                ) : (
                    <EmailAttachmentViewOnly
                        fieldData={fieldData}
                        detailTicket={detailTicket}
                        setIsShowPopupLogout={setIsShowPopupLogout}
                    />
                )}
            </div>
        </div>
    );
}

const EmailAttachmentViewOnly = ({fieldData, detailTicket, setIsShowPopupLogout}) => {

    const formatBytes = (bytes, decimals = 2) => {
        if (!+bytes) return '0 B'
    
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    
        const i = Math.floor(Math.log(bytes) / Math.log(k))
    
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }

    const renderImageFile = (fileImageList) => {
        let fileImageComponentList = [];
        fileImageList?.forEach((item,index) => {
            let tempFile =  { ...item, type: 1 };
            let imgSrc = getLinkDownloadFileFromS3(tempFile, detailTicket, null, Constant.ATTACH_FILE.VIEW_TICKET_DETAIL);

            fileImageComponentList.push(
                <li className="justify-content-center">
                    <div className="display-thumb">
                        <div className="class-relative cursor-default listmap-item">
                            <TooltipThumb
                                value={`${item.fileName}(${formatBytes(item.fileSize)})`}
                                className="titleDisplay"
                            >
                                <img
                                    src={imgSrc}
                                    alt=""
                                    aria-label="more"
                                    aria-controls="long-menu"
                                    aria-haspopup="true"
                                    onClick={e => {
                                        downloadFileFromS3(tempFile, detailTicket, false, false, '', setIsShowPopupLogout);
                                    }}
                                />
                            </TooltipThumb>
                        </div>
                        <div className="text-truncate text-center cursor-default">
                            {`${item.fileName}(${formatBytes(item.fileSize)})`}
                        </div>
                    </div>
                </li>
            );
        })
        return fileImageComponentList;
    }

    const renderOtherFile = (otherFileList) => {
        let fileImageComponentList = [];
        otherFileList?.forEach((file,index) => {
            let tempFile =  { type: 1, ...file };
            fileImageComponentList.push(
                <li>
                    <a  className="file-upload-name--change file-upload-active"
                        target="_blank"
                        onClick={e => {
                            e.preventDefault();
                            downloadFileFromS3(tempFile, detailTicket, false, false, '', setIsShowPopupLogout);
                        }}
                        href="!#"
                    >
                        <OverFlowTooltip
                            value={`${file.fileName}(${formatBytes(file.fileSize)})`}
                            className={'link-file-name'}
                        ></OverFlowTooltip>
                    </a>
                </li>
            );
        })
        return fileImageComponentList;
    }


    let fileList = fieldData.value;
    let fileImageList =  fileList.filter(item => Utils.isImageFile(item.fileName));
    let otherFileList = fileList.filter(item => !Utils.isImageFile(item.fileName));

    return (
        <div className="lstName-file">
            <ul>
                {renderImageFile(fileImageList)}
                {renderOtherFile(otherFileList)}
            </ul>
        </div>
    )
}
